import { FooterTemplate } from '@global-footer/types';

/**
 * Parse CSS selector syntax into FooterTemplate array
 * Examples:
 *   "a.link" => [{ tag: 'a', className: 'link' }]
 *   "li.item a.link span" => [{ tag: 'li', className: 'item' }, { tag: 'a', className: 'link' }, { tag: 'span' }]
 *   "li.nav-item.active a" => [{ tag: 'li', className: 'nav-item active' }, { tag: 'a' }]
 */
export const parseFooterTemplate = (
  selector: string
): FooterTemplate | null => {
  try {
    const layers = selector.trim().split(/\s+/);

    return layers.map((layer) => {
      const parts = layer.split('.');
      const tag = parts[0];
      const className = parts.slice(1).join(' ');

      if (!tag) {
        throw new Error(`Missing tag name in layer: ${layer}`);
      }

      return {
        tag,
        className: className || undefined
      };
    });
  } catch (error) {
    console.warn('cbgCompPack: Invalid data-footer-template syntax:', error);
    return null;
  }
};
